import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Button } from 'foundations-components/transitional/components/Button';
import { DeleteIcon } from 'foundations-assets';
import { fromJS } from 'immutable';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ConfigRemoveConditionalFormattingButton = ({
  report,
  onClick,
  selectedColumnName,
  onChange
}) => {
  const handleColumnChange = () => {
    const conditionalFormatting = {
      useConditionalFormatting: false
    };
    return report.setIn(['displayParams', 'columns', selectedColumnName, 'format', 'conditionalFormatting'], fromJS(conditionalFormatting));
  };
  return /*#__PURE__*/_jsx(Button, {
    onClick: () => {
      const nextReport = handleColumnChange();
      onClick(selectedColumnName);
      onChange(nextReport);
    },
    use: "link",
    children: /*#__PURE__*/_jsxs(Flex, {
      children: [/*#__PURE__*/_jsx(DeleteIcon, {
        size: "400"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "report-customization-components.customization-components.conditional-formatting.remove-button"
      })]
    })
  });
};